import { render, staticRenderFns } from "./DeliveryEndereco.vue?vue&type=template&id=20cc388b&"
import script from "./DeliveryEndereco.vue?vue&type=script&lang=js&"
export * from "./DeliveryEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports